import React, { useRef, useState } from 'react';
import ListItemText from '@mui/material/ListItemText';
import { Typography } from '../../../Typography/Typography';
import { shouldEnableTooltip, Tooltip } from '../../../Tooltip';
import { CreatableOption, OptionTypeWithCode } from '../../types';
import { Embolden } from '../../../Embolden/Embolden';
import { isCreatableOption } from '../utils/guards';
import { SelectIconWrapper } from './SelectIconWrapper';
import { SecondaryLabels } from './SecondaryLabelItem';
import { Grid } from '../../../Grid';
import { ExtraOption } from './ExtraOption';

export const InnerMenuItem: React.FC<
  React.PropsWithChildren<{
    optionProps: React.HTMLAttributes<HTMLElement>;
    option: OptionTypeWithCode | CreatableOption;
    dataTest: string;
    searchTerm?: string;
    noWrapSubLabel?: boolean;
    iconSize?: 'small' | 'medium';
  }>
> = ({ option, dataTest, searchTerm, noWrapSubLabel, optionProps, iconSize }) => {
  const [showTooltip, setTooltipState] = useState(false);
  const typographyRef = useRef<HTMLDivElement>(null);

  if (isCreatableOption(option)) {
    return (
      <ExtraOption {...optionProps} data-test={`${dataTest}-list-item-create-value`} primary={option.creatableTitle} />
    );
  }

  let dataValue: string;
  try {
    dataValue = typeof option.value === 'object' ? JSON.stringify(option.value) : option.value;
  } catch (e) {
    dataValue = '';
  }
  return (
    <>
      {/* @ts-ignore optionProps are valid */}
      <ListItemText
        {...optionProps}
        data-test={`${dataTest}-list-item`}
        data-test-label={option.label}
        data-value={dataValue}
        primary={
          <Grid columns={12} container direction="row" spacing={2} width="100%" alignItems="center">
            {!!option.icon && (
              <Grid size="auto">
                <SelectIconWrapper variant={iconSize}>{option.icon}</SelectIconWrapper>
              </Grid>
            )}
            <Grid size="grow">
              <Typography
                dataTest="overflow-typography"
                component="div"
                noWrap
                ref={typographyRef}
                onMouseEnter={() => setTooltipState(shouldEnableTooltip(typographyRef.current))}
              >
                <Tooltip title={option.label} dataTest="select-item-tooltip" placement="top" disabled={!showTooltip}>
                  <Embolden term={searchTerm}>{option.label}</Embolden>
                </Tooltip>
              </Typography>
              <SecondaryLabels option={option} noWrapSubLabel={!!noWrapSubLabel} />
            </Grid>
          </Grid>
        }
        style={{ opacity: option.value !== null && typeof option.value !== 'undefined' ? 1 : 0.5 }}
        slotProps={{
          primary: {
            component: 'div'
          }
        }}
      />
    </>
  );
};
